/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the className name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { MediaUpload, RichText, useBlockProps } from "@wordpress/block-editor";

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
export default function Edit({ attributes, setAttributes }) {
	return (
		<section {...useBlockProps()}>
			<div className="placed-tiles-container">
				<div
					style={{
						backgroundImage: `url('${placedTilesData.wavesIllustration}')`,
					}}
					className="waves-illustration"
				></div>

				<div className="placed-tiles-content">
					<div className="placed-tiles-heading">
						<RichText
							tagName="h2"
							value={attributes.title}
							onChange={(str) => setAttributes({ title: str })}
							placeholder="Add a title..."
						/>

						<RichText
							tagName="p"
							value={attributes.subtitle}
							onChange={(str) => setAttributes({ subtitle: str })}
							placeholder="Add a subtitle..."
						/>
					</div>

					<div className="placed-tiles">
						<div className="tile">
							<MediaUpload
								onSelect={(media) => setAttributes({ picto1: media.url })}
								allowedTypes={["image"]}
								render={({ open }) => (
									<button onClick={open} className="button button-large">
										{attributes.picto1 ? (
											<img src={attributes.picto1} alt="Selected image" />
										) : (
											"Upload Image"
										)}
									</button>
								)}
							/>

							<RichText
								tagName="p"
								value={attributes.tile1}
								onChange={(str) => setAttributes({ tile1: str })}
								placeholder="Add a text..."
							/>
						</div>

						<div className="tile">
							<MediaUpload
								onSelect={(media) => setAttributes({ picto2: media.url })}
								allowedTypes={["image"]}
								render={({ open }) => (
									<button onClick={open} className="button button-large">
										{attributes.picto2 ? (
											<img src={attributes.picto2} alt="Selected image" />
										) : (
											"Upload Image"
										)}
									</button>
								)}
							/>

							<RichText
								tagName="p"
								value={attributes.tile2}
								onChange={(str) => setAttributes({ tile2: str })}
								placeholder="Add a text..."
							/>
						</div>

						<div className="tile">
							<MediaUpload
								onSelect={(media) => setAttributes({ picto3: media.url })}
								allowedTypes={["image"]}
								render={({ open }) => (
									<button onClick={open} className="button button-large">
										{attributes.picto3 ? (
											<img src={attributes.picto3} alt="Selected image" />
										) : (
											"Upload Image"
										)}
									</button>
								)}
							/>

							<RichText
								tagName="p"
								value={attributes.tile3}
								onChange={(str) => setAttributes({ tile3: str })}
								placeholder="Add a text..."
							/>
						</div>

						<div className="tile">
							<MediaUpload
								onSelect={(media) => setAttributes({ picto4: media.url })}
								allowedTypes={["image"]}
								render={({ open }) => (
									<button onClick={open} className="button button-large">
										{attributes.picto4 ? (
											<img src={attributes.picto4} alt="Selected image" />
										) : (
											"Upload Image"
										)}
									</button>
								)}
							/>

							<RichText
								tagName="p"
								value={attributes.tile4}
								onChange={(str) => setAttributes({ tile4: str })}
								placeholder="Add a text..."
							/>
						</div>

						<div className="tile">
							<MediaUpload
								onSelect={(media) => setAttributes({ picto5: media.url })}
								allowedTypes={["image"]}
								render={({ open }) => (
									<button onClick={open} className="button button-large">
										{attributes.picto5 ? (
											<img src={attributes.picto5} alt="Selected image" />
										) : (
											"Upload Image"
										)}
									</button>
								)}
							/>

							<RichText
								tagName="p"
								value={attributes.tile5}
								onChange={(str) => setAttributes({ tile5: str })}
								placeholder="Add a text..."
							/>
						</div>

						<div className="tile">
							<MediaUpload
								onSelect={(media) => setAttributes({ picto6: media.url })}
								allowedTypes={["image"]}
								render={({ open }) => (
									<button onClick={open} className="button button-large">
										{attributes.picto6 ? (
											<img src={attributes.picto6} alt="Selected image" />
										) : (
											"Upload Image"
										)}
									</button>
								)}
							/>

							<RichText
								tagName="p"
								value={attributes.tile6}
								onChange={(str) => setAttributes({ tile6: str })}
								placeholder="Add a text..."
							/>
						</div>

						<div className="tile">
							<MediaUpload
								onSelect={(media) => setAttributes({ picto7: media.url })}
								allowedTypes={["image"]}
								render={({ open }) => (
									<button onClick={open} className="button button-large">
										{attributes.picto7 ? (
											<img src={attributes.picto7} alt="Selected image" />
										) : (
											"Upload Image"
										)}
									</button>
								)}
							/>

							<RichText
								tagName="p"
								value={attributes.tile7}
								onChange={(str) => setAttributes({ tile7: str })}
								placeholder="Add a text..."
							/>
						</div>

						<div className="tile">
							<MediaUpload
								onSelect={(media) => setAttributes({ picto8: media.url })}
								allowedTypes={["image"]}
								render={({ open }) => (
									<button onClick={open} className="button button-large">
										{attributes.picto8 ? (
											<img src={attributes.picto8} alt="Selected image" />
										) : (
											"Upload Image"
										)}
									</button>
								)}
							/>

							<RichText
								tagName="p"
								value={attributes.tile8}
								onChange={(str) => setAttributes({ tile8: str })}
								placeholder="Add a text..."
							/>
						</div>

						<div className="tile">
							<MediaUpload
								onSelect={(media) => setAttributes({ picto9: media.url })}
								allowedTypes={["image"]}
								render={({ open }) => (
									<button onClick={open} className="button button-large">
										{attributes.picto9 ? (
											<img src={attributes.picto9} alt="Selected image" />
										) : (
											"Upload Image"
										)}
									</button>
								)}
							/>

							<RichText
								tagName="p"
								value={attributes.tile9}
								onChange={(str) => setAttributes({ tile9: str })}
								placeholder="Add a text..."
							/>
						</div>

						<div className="tile">
							<MediaUpload
								onSelect={(media) => setAttributes({ picto10: media.url })}
								allowedTypes={["image"]}
								render={({ open }) => (
									<button onClick={open} className="button button-large">
										{attributes.picto10 ? (
											<img src={attributes.picto10} alt="Selected image" />
										) : (
											"Upload Image"
										)}
									</button>
								)}
							/>

							<RichText
								tagName="p"
								value={attributes.tile10}
								onChange={(str) => setAttributes({ tile10: str })}
								placeholder="Add a text..."
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
